import axios from 'axios';

class ExternalAPIClient {
	// constructor(baseURL) {
	//     this.axiosInstance = axios.create({});
	//     this.baseURL = baseURL;
	//     this.token = null;
	//     this.axiosInstance.defaults.headers.post['Content-Type'] = 'application/json';
	// }

	constructor(baseURL) {
		this.baseURL = baseURL;
		this.token = null;
		// Crear la instancia de axios con baseURL directamente en la configuración
		this.axiosInstance = axios.create({
			baseURL: this.baseURL,
			headers: {
				'Content-Type': 'application/json',
			},
		});
	}

	/**
	 * Autenticación OAuth2 password grant contra Facele/GBusiness.
	 * Importante: la URL debe ser solo '/token' (path relativo al baseURL de axios).
	 * Si se usara `${this.baseURL}/token` con baseURL undefined, el template produce el
	 * string literal "undefined/token"; axios lo trata como URL relativa y la resuelve
	 * contra la ruta actual del SPA (p. ej. /warehouse/guide/register → .../guide/undefined/token).
	 */
	async authenticate(username, password) {
		try {
			const response = await this.axiosInstance.post(
				'/token', // Usar path relativo, baseURL ya está configurado en axiosInstance
				new URLSearchParams({
					username,
					password,
					grant_type: 'password',
					scope: 'data.read',
				}),
				{
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
					},
				},
			);

			if (response && response['data']['access_token']) {
				this.setAuthorization(response['data']['access_token']);
				return response['data']['access_token'];
			} else {
				throw new Error(
					'Token no encontrado en la respuesta de autenticación.',
				);
			}
		} catch (error) {
			console.error(
				'Error durante la autenticación:',
				error.response?.data?.message || error.message,
			);
			throw error;
		}
	}

	// Configurar el token de autorización para futuras solicitudes
	setAuthorization(token) {
		this.token = token;
		this.axiosInstance.defaults.headers.common['Authorization'] =
			`Bearer ${token}`;
	}

	// Método GET
	// get(url, options) {
	//     this.axiosInstance.defaults.baseURL = this.baseURL;
	//     return options && Object.keys(options).length > 0
	//         ? this.this.axiosInstance.get(url, options)
	//         : this.axiosInstance.get(url);
	// }

	// Método GET
	get(url, options) {
		return options && Object.keys(options).length > 0
			? this.axiosInstance.get(url, options)
			: this.axiosInstance.get(url);
	}

	// Método POST
	post(url, data, options) {
		this.axiosInstance.defaults.baseURL = this.baseURL;
		return options && Object.keys(options).length > 0
			? this.axiosInstance.post(url, data, options)
			: this.axiosInstance.post(url, data);
	}

	// Método PATCH
	update(url, data) {
		this.axiosInstance.defaults.baseURL = this.baseURL;
		return this.axiosInstance.patch(url, data);
	}

	// Método PUT
	put(url, data) {
		this.axiosInstance.defaults.baseURL = this.baseURL;
		return this.axiosInstance.put(url, data);
	}

	// Método DELETE
	delete(url, config) {
		this.axiosInstance.defaults.baseURL = this.baseURL;
		return this.axiosInstance.delete(url, { ...config });
	}
}

export default ExternalAPIClient;
